import * as z from "zod/v4";

export const aeoGranularity = ["daily", "weekly"] as const;
export type AeoGranularity = (typeof aeoGranularity)[number];

export const CANONICAL_AEO_MODELS = [
  "chatgpt",
  "claude",
  "gemini",
  "google_aimode",
  "grok",
  "perplexity",
] as const;
export type CanonicalAeoModel = (typeof CANONICAL_AEO_MODELS)[number];

const aeoDateRangeInput_ = z.object({
  startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  endDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  models: z.array(z.string()).optional(),
  granularity: z.enum(aeoGranularity).optional(),
});

export const aeoDateRangeInput: z.ZodType<AeoDateRangeInput> =
  aeoDateRangeInput_;
export interface AeoDateRangeInput extends z.infer<typeof aeoDateRangeInput_> {}
